import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import videoPreviewImage from "./carouselVideos/videoPreviewImage.png";
import VideoCarousel from "@common/VideoCarousel/VideoCarousel";
import vid1 from "./carouselVideos/WP-Snippet-01.mp4";
import vid1small from "./carouselVideos/WP-Snippet-01-small.mp4";
import vid2 from "./carouselVideos/WP-Snippet-02.mp4";
import vid2small from "./carouselVideos/WP-Snippet-02-small.mp4";
import vid3 from "./carouselVideos/WP-Snippet-03.mp4";
import vid3small from "./carouselVideos/WP-Snippet-03-small.mp4";
import vid4 from "./carouselVideos/WP-Snippet-04.mp4";
import vid4small from "./carouselVideos/WP-Snippet-04-small.mp4";
import styles from "./Home.module.scss";
import Button from "@common/Button/Button";
import classNames from "classnames";
import gif from "@graphics/home/powerdocs_icons_V2_transparent.gif";
import gif_mobile from "@graphics/home/powerdocs_icons_mobile__V2_transparent.gif";
import { Link } from "react-router-dom";
import config from "@config";

// TODO: either finish porting this or maybe just copy over the whole thing from other frontend

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIntVideo: 1,
      videos: [
        { normal: vid1, small: vid1small },
        { normal: vid2, small: vid2small },
        { normal: vid3, small: vid3small },
        { normal: vid4, small: vid4small },
      ],
    };
  }
  componentDidMount() {}

  componentWillReceiveProps(props) {}

  componentWillUnmount() {}

  renderVideoSlider() {
    const getVideoTag = (file) => {
      return (
        <video
          id="intVideo"
          style={{ width: "100%" }}
          autoPlay
          muted
          poster={videoPreviewImage}>
          <source src={file} type="video/mp4" key="mp4" />
        </video>
      );
    };

    let content = _.map(this.state.videos, (val, index) => {
      let vid;
      vid = val.small; //domHelper.isMobile ? val.small : val.normal;  // TODO: add mobile detection for vid resolution
      return <span key={index}>{getVideoTag(vid)}</span>;
    });
    return (
      <div>
        {/* 
          <div className={classNames(styles.section, styles.sectionVideo)}>
            <VideoCarousel>
              {content}
            </VideoCarousel>
          </div>          
          <div className={classNames(styles.section, styles.sectionPublishNow)}>
            <div>
              <div className={styles.bigText}>
                35 million documents
                connected in one place.
                Publish yours today!
              </div>
              <Button type="secondary">Start publishing for free</Button>
            </div>
          </div>
          <div className={classNames(styles.section, styles.sectionSearch)}>
            <div className={styles.bigText}>Every answer starts with a question!</div>
          </div>
          <div className={classNames(styles.section, styles.sectionSteps)}>
              <div className={styles.bigText}>
                4 easy steps to all the content you wish for
              </div>
          </div>
          */}
      </div>
    );
  }

  render() {
    const { auth } = this.props;
    const _height = window.innerHeight - 43;
    return (
      <div className={styles.home} style={{ height: `${_height}px` }}>
        <div>
          {window.innerWidth >= config.responsive.mobil ? (
            <img src={gif} />
          ) : (
            <img src={gif_mobile} />
          )}
          <div className={styles.text}>
            {auth.user ? (
              <>
                <div
                  style={{ maxWidth: "500px", textAlign: "center" }}
                  className="h2">
                  NOW YOU’RE READY TO PIMP & PUBLISH
                </div>
                <Link to="/dashboard/documents/add">
                  <Button type="primary">Publish now</Button>
                </Link>
              </>
            ) : (
              <>
                <h2>PIMP & PUBLISH</h2>
                <div className={styles.wrappedText}>
                  Add new features to your PDF and amaze others with your
                  powerful documents!
                </div>
                <Link to="/auth">
                  <Button type="primary">Start publishing for free</Button>
                </Link>
              </>
            )}
          </div>
        </div>
        {/* {this.renderVideoSlider()} */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Home);
